import type { Entities } from '@inwink/entities/entities';
import { getRouteTargetPage } from '@inwink/react-utils/navigation/getroutetargetpage';
import { previewHost } from '@@data/preview';
import { getEventPreviewId } from '@@event/api/eventdetail';
import { getFrontTargetRoutePage } from '@inwink/react-utils/navigation';
import { IFrontTargetRoutePageOptions } from '@inwink/react-utils/navigation/types';

export function getEventPreviewTinyUrl(detail: Entities.IEventDetail): Promise<string> {
    const tinyUrl = (detail as any).eventKey || (detail as any).tinyUrl;
    return getEventPreviewId(detail.id).then((res) => {
        return tinyUrl + "_" + res.previewId;
    });
}

export function getEventPreviewUrl(detail: Entities.IEventDetail): Promise<string> {
    return getEventPreviewTinyUrl(detail).then((res) => {
        return previewHost(detail.previewHost) + res;
    });
}

export function openEventPreview(
    eventdetail: Entities.IEventDetail,
    _url = "",
    name = "inwinkpreview",
    pageAlias?,
    _pageType?
) {
    let pageType = _pageType;
    let url = _url;
    if (pageType === "contentpage") {
        pageType = "content";
    }

    const targetPage = getRouteTargetPage(pageAlias, null, null, true);
    if (pageAlias && pageType) {
        // remove 'page' when redirecting on root page
        if (targetPage.length === 0) { pageType = null; }
        url = (pageType ? pageType + '/' : "") + targetPage;
    }

    return getEventPreviewUrl(eventdetail).then((previewUrl) => {
        window.open(previewUrl + "/" + url, name, "");
    });
}

export function openEventCMS(
    eventdetail: Entities.IEventDetail,
    _url?,
    _name?,
    pageAlias?: string,
    _pageType?: string,
    application?: string,
    options?: IFrontTargetRoutePageOptions<Entities.IEventPageNavigationContext>,
    openBlankFirst?: boolean
) {
    let pageType = _pageType;
    let url = _url ?? "";
    const name = _name ?? "inwinkcms";
    if (pageType === "contentpage") {
        pageType = "content";
    }
    const appLink = {
        application: application,
        target: pageAlias
    };
    const targetPage = getFrontTargetRoutePage(appLink, options);
    if (pageAlias && pageType) {
        // remove 'page' when redirecting on root page
        if (targetPage.length === 0 || pageType === "page") { pageType = null; }
        url = (pageType ? pageType + '/' : "") + targetPage;
    }

    let blankWindow;
    if (openBlankFirst) {
        blankWindow = window.open("", name, "");
    }

    return getEventPreviewTinyUrl(eventdetail).then((res) => {
        let rooturl = "/preview/";
        if (window.location.host === "localhost:8282") {
            rooturl = "/dev.html#/preview/";
        }
        if (blankWindow) {
            blankWindow.location.href = `${rooturl}${res}/${url}`;
        } else {
            window.open(`${rooturl}${res}/${url}`, name, "");
        }
    });
}